<template>
  <div>
    <apexchart
      type="area"
      :height="$vuetify.breakpoint.smAndDown ? 200 : 350"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "App",
  props: {
    loginChart: {
      name: [],
      data: [],
    },
  },
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      series: [],
      chartOptions: {
        colors: ["#197CFF"],
        chart: {
          type: "area",
          stacked: true,
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true,
          },
          toolbar: {
            autoSelected: "zoom",
          },
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            shadeIntensity: 0.5,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 0.4,
            stops: [0, 100],
          },
        },
        xaxis: {
          type: "datetime",
          labels: {
            formatter: function (value) {
              var date = new Date(value);
              var day = date.getDate() + 1;
              var month = date.getMonth() + 1;
              var monthsAbbrPt = [
                "Jan",
                "Fev",
                "Mar",
                "Abr",
                "Mai",
                "Jun",
                "Jul",
                "Ago",
                "Set",
                "Out",
                "Nov",
                "Dez",
              ];
              var monthAbbrPt = monthsAbbrPt[month];
              return `${day} ${monthAbbrPt}`; // Format the date in Brazilian date format
            },
          },
        },
      },
    };
  },
  created() {
    this.updateLogin();
  },
  methods: {
    updateLogin() {
      setTimeout(() => {
        const { name, data } = this.loginChart;

        this.series = [{ name: this.$t('student.student_acesso.acesso'), data: data }];
        this.chartOptions = {
          xaxis: {
            categories: name,
          },
        };
      }, 500);
    },
  },
};
</script>

<style></style>
